// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseUrlSelect_showHideBtn__\\+3d2r {
  position: fixed;
  top: 64px;
  left: 32px;
  opacity: 0;
  transition: all 0.3s ease-out;
  transform: rotate(0deg) scale(0.5);
  cursor: pointer;
  font-size: 10px;
  font-weight: 600;
  width: 48px;
  height: 48px;
}
.BaseUrlSelect_showHideBtn__\\+3d2r:hover {
  opacity: 0.1;
  transform: rotate(360deg) scale(1.2);
}
.BaseUrlSelect_selectsContainer__ebX9Q {
  position: fixed;
  top: 32px;
  right: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 16px;
}
.BaseUrlSelect_selectContainer__OpWna {
  width: 280px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DefaultPages/Home/BaseUrlSelect/BaseUrlSelect.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,UAAU;EACV,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,YAAY;AACd","sourcesContent":[".showHideBtn {\r\n  position: fixed;\r\n  top: 64px;\r\n  left: 32px;\r\n  opacity: 0;\r\n  transition: all 0.3s ease-out;\r\n  transform: rotate(0deg) scale(0.5);\r\n  cursor: pointer;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  width: 48px;\r\n  height: 48px;\r\n}\r\n.showHideBtn:hover {\r\n  opacity: 0.1;\r\n  transform: rotate(360deg) scale(1.2);\r\n}\r\n.selectsContainer {\r\n  position: fixed;\r\n  top: 32px;\r\n  right: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  row-gap: 16px;\r\n}\r\n.selectContainer {\r\n  width: 280px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showHideBtn": `BaseUrlSelect_showHideBtn__+3d2r`,
	"selectsContainer": `BaseUrlSelect_selectsContainer__ebX9Q`,
	"selectContainer": `BaseUrlSelect_selectContainer__OpWna`
};
export default ___CSS_LOADER_EXPORT___;
